import { AppsListClass } from './component/AppsListClass';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import globals from '@descope-ui/theme-globals';

export const vars = AppsListClass.cssVarList;
const globalRefs = getThemeRefs(globals);

const defaultHeight = '400px';

const appsList = {
  [vars.itemsTextAlign]: 'start',
  [vars.hostDirection]: globalRefs.direction,
  [vars.maxHeight]: defaultHeight,
  [vars.itemHoverBackgroundColor]: globalRefs.colors.surface.highlight,

  _empty: {
    [vars.minHeight]: defaultHeight,
  },

  size: {
    xs: {
      [vars.itemsFontSize]: '14px',
      [vars.itemsFontWeight]: 'normal',
    },
    sm: {
      [vars.itemsFontSize]: '14px',
      [vars.itemsFontWeight]: 'normal',
    },
    md: {
      [vars.itemsFontSize]: '16px',
      [vars.itemsFontWeight]: 'normal',
    },
    lg: {
      [vars.itemsFontSize]: '20px',
      [vars.itemsFontWeight]: 'normal',
    },
  },

  itemPadding: {
    xs: {
      [vars.itemVerticalPadding]: globalRefs.spacing.xs,
      [vars.itemHorizontalPadding]: globalRefs.spacing.xs,
    },
    sm: {
      [vars.itemVerticalPadding]: globalRefs.spacing.sm,
      [vars.itemHorizontalPadding]: globalRefs.spacing.sm,
    },
    md: {
      [vars.itemVerticalPadding]: globalRefs.spacing.md,
      [vars.itemHorizontalPadding]: globalRefs.spacing.md,
    },
    lg: {
      [vars.itemVerticalPadding]: globalRefs.spacing.lg,
      [vars.itemHorizontalPadding]: globalRefs.spacing.lg,
    },
    xl: {
      [vars.itemVerticalPadding]: globalRefs.spacing.xl,
      [vars.itemHorizontalPadding]: globalRefs.spacing.xl,
    },
  },
};

export default appsList;
